module.exports = "<ng-container *ngIf=\"content | async as series\">\n    <row-header [row$]=\"series\" [showCount]=\"true\" [fullCopy]=\"true\" [showSubhead]=\"true\" class=\"featured container header\" *ngIf=\"(series|meta); let meta\"></row-header>\n    <div class=\"series-list\" *ngIf=\"getSeriesSlides(series); let slides\">\n        <episode-carousel [slides]=\"slides\" [clickDisabled]=\"true\"></episode-carousel>\n    </div>\n    <rows [rows$]=\"series.rows\" [initialIndex]=\"1\">\n    </rows>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/series-container/series-container.template.html
// module id = 872
// module chunks = 2